import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'duty', 'location', 'startsAt', 'endsAt' ]

  dutyChanged(_event) {
    this.locationTarget.textContent = this.location
    this.startsAtTarget.textContent = this.startsAt
    this.endsAtTarget.textContent = this.endsAt

    const newDutyId = this.selectedOption.getAttribute('value')

    this.dispatch('duty-changed', { detail: { new_duty_id: newDutyId } } )
  }

  removeRotaShiftRow(event) {
    event.preventDefault()

    this.dispatch('rota-shift-removed', { detail: { row_index: event.params.rowIndex } } )
  }

  get startsAt() {
    return this.ar ? null : this.selectedOption.getAttribute('data-starts-at')
  }

  get endsAt() {
    return this.ar ? null : this.selectedOption.getAttribute('data-ends-at')
  }

  get location() {
    return this.selectedOption.getAttribute('data-location')
  }

  get selectedOption() {
    return this.dutyTarget.options[this.dutyTarget.selectedIndex]
  }

  ar() {
    return this.selectedOption.getAttribute('data-ar') == 'true'
  }
}
